import { createContext, useContext } from "react";
import { assert } from "utils";

import { type LabelsRepository } from "src/repositories/labels/LabelsRepository";

export const LabelsRepositoryContext = createContext<LabelsRepository | null>(
  null,
);

export function useLabelsRepository(): LabelsRepository {
  const repository = useContext(LabelsRepositoryContext);
  assert(repository, "LabelsRepositoryContext is missing");
  return repository;
}
